import React, { ChangeEventHandler, ComponentType, useCallback } from 'react';

interface OriginalHandler {
    onChange?: ChangeEventHandler<HTMLInputElement>;
}

interface OverriddenHandler {
    onChange: (value: string) => void;
}

export default function withOverriddenHandler<TProps extends OriginalHandler>(
    Component: ComponentType<TProps>
) {
    type Props = Omit<TProps, 'onChange'> & OverriddenHandler;

    const WrappedComponent = (props: Props) => {
        const { onChange, ...restProps } = props;
        
        const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>((event) => {
            onChange(event.target.value);
        }, [ onChange ]);

        return (
            <Component { ...(restProps as unknown as TProps) }
                onChange={ handleChange }
            />
        );
    };

    const name = Component.displayName || Component.name || 'Component';

    WrappedComponent.displayName = `withOverriddenHandler(${ name })`;

    return WrappedComponent;
}
